export const accessLevels = ["viewer", "operator", "administrator"] as const;
